import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

import { config } from 'app/config';
import { data } from 'services';
import { getTextWidth } from 'libs/common';
import { required as requiredValidation } from '../validation';
import { Multiselect } from './fields';
import { MultiInput } from './multi-input';
import { StyledSelect } from './dict-filter.styled';

export const DictFilter = (props) => {
  const { t } = useTranslation();
  const {
    exclude = [],
    theme = '',
    multiple = false,
    withEmpty = true,
    emptyName = t('filter.Все'),
    required = false,
    title = '',
    titles = {},
    name,
    dict,
    force_name,
    w,
    ...rest
  } = props;
  // const wOk = w + 'px';
  const requiredT = useCallback(requiredValidation(t), [t]);
  if (required) {
    rest.validate = requiredT;
  }

  // array of dict name
  const dictOk = !Array.isArray(dict) ? [dict] : dict;
  let dictionaryParam = '';
  let dictionaryTitle = '';

  // get items
  const getDictItems = () => {
    const out = [];
    dictOk.forEach((dictName) => {
      const dictionary = data.getDict(dictName);
      if (dictionary) {
        if (!dictionaryParam) {
          dictionaryParam = dictionary.param;
          dictionaryTitle = dictionary.title;
        }
        dictionary.items
          .filter((el) => !exclude.includes(el.value))
          .forEach((el) => {
            out.push({ name: titles[el.name] ?? el.name, value: dictOk.length > 1 ? dictionary.param + '|' + el.value : el.value });
          });
      }
    });

    return out;
  };

  // items
  const items = getDictItems();

  // get items el
  const getItemsEl = () => {
    return items.map((el, idx) => {
      let val = el.value;
      return (
        <option key={idx} value={val}>
          {el.name}
        </option>
      );
    });
  };

  const title1Ok = !!title ? title : dictionaryTitle;
  const title1 = t(`dict_filter.${title1Ok}`);

  const nameOk = force_name ?? dictionaryParam ?? name;
  const optionsEl = getItemsEl();
  const titleOk = title1 + (required ? config.req : '');

  // multiple
  if (multiple) {
    const itemsOk = items.map((el) => {
      return { id: el.value, name: el.name };
    });
    return <Multiselect type="multiselect" label={titleOk} additionalComponent={MultiInput} data={itemsOk} countDisplayedIcons={3} name={nameOk} theme={theme} {...rest} />;
  }

  const findMaxWidth = () => {
    let maxString = '';
    if (w) {
      return w.toString() + 'px';
    }

    items.forEach((el) => {
      if (el.name.length > maxString.length) {
        maxString = el.name;
      }
    });

    return getTextWidth(maxString) + 35 + 'px';
  };

  const width = findMaxWidth();

  return (
    <StyledSelect type="select" width={width} name={nameOk} label={titleOk} theme={theme} {...rest}>
      {withEmpty && <option value="">{emptyName}</option>}
      {optionsEl}
    </StyledSelect>
  );
};

DictFilter.propTypes = {
  dict: PropTypes.any.isRequired, //string.isRequired | PropTypes.array.isRequired,
  name: PropTypes.string,
  title: PropTypes.string,
  multiple: PropTypes.bool,
  type: PropTypes.string,
  theme: PropTypes.string,
  exclude: PropTypes.array,
  titles: PropTypes.object,
};
